import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useResponsive from './responsive/useResponsive';

function UpdateFileNotesDialog({
  open,
  onClose,
  currentNotes,
  onSave,
  saving = false,
}) {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (open) {
      setNotes(currentNotes || '');
    }
  }, [open, currentNotes]);

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
    >
      <DialogTitle>{t('common.updateNotes')}</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          margin="dense"
          label={t('common.notes')}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>{t('common.cancel')}</Button>
        <Button
          variant="contained"
          onClick={() => onSave(notes.trim() || null)}
          disabled={saving}
        >
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateFileNotesDialog;
